import { render, staticRenderFns } from "./LoanApprovalTable.vue?vue&type=template&id=749be5cb&scoped=true"
import script from "./LoanApprovalTable.vue?vue&type=script&lang=js"
export * from "./LoanApprovalTable.vue?vue&type=script&lang=js"
import style0 from "./LoanApprovalTable.vue?vue&type=style&index=0&id=749be5cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "749be5cb",
  null
  
)

export default component.exports